import { formatNumberToCurrency, presentNumberToCurrencyTable } from '@/services/formatter_services/currency-formatter';
import { formatBool } from '@/utils/shared';
import dateFormatter from '@/services/formatter_services/date-formatter';

const ACTIVITY_WIDGETS = Object.freeze({
  ACTIVITY_WIDGETS: [
    {
      id: 'activities',
      path: 'activities',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        {
          text: 'Common.date',
          value: 'fromDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        { text: 'Common.label', value: 'label' },
        {
          text: 'Common.status',
          value: 'status'
        },
        {
          text: 'Common.company',
          value: 'connectedCompanies'
        },
        {
          text: 'Common.employee',
          value: 'connectedEmployees'
        },
        {
          text: 'Dashboard.widgets.activities.headers.finished',
          value: 'finishedAt',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Common.gross',
          value: 'totalGrossSum',
          presentWith: presentNumberToCurrencyTable,
          alignValue: 'right',
        },
        {
          text: 'Common.net',
          value: 'totalNetSum',
          presentWith: presentNumberToCurrencyTable,
          alignValue: 'right',
        },
        { text: 'Common.type', value: 'type' }
      ],
      type: 'TABLE',
      moduleId: 'activities',
      withRouterActionLink: true
    },
    {
      id: 'activitiesAmount',
      path: 'activities',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'activities'
    },
    {
      id: 'activitiesNetSum',
      path: 'activities',
      type: 'VALUE',
      presentWith: formatNumberToCurrency,
      alignValue: 'right',
      getData: response => response.data.aggregations.totalNetSum,
      moduleId: 'activities'
    },
    {
      id: 'activitiesGrossSum',
      path: 'activities',
      type: 'VALUE',
      presentWith: formatNumberToCurrency,
      alignValue: 'right',
      getData: response => response.data.aggregations.totalGrossSum,
      moduleId: 'activities'
    }
  ],
  EMAILS_WIDGETS: [
    {
      id: 'emailsOverview',
      path: 'emails',
      getData: response => response.data.data?.emailList,
      headers: [
        { text: 'Dashboard.widgets.emailsOverview.headers.sender', value: 'sender' },
        { text: 'Common.label', value: 'label' },
        {
          text: 'Common.date',
          value: 'date',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Dashboard.widgets.emailsOverview.headers.isWorkMail',
          value: 'isWorkMail',
          presentWith: formatBool
        }
      ],
      type: 'TABLE',
      moduleId: 'emails',
      withRouterActionLink: true
    },
    {
      id: 'emailsAmount',
      path: 'emails',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'emails'
    }
  ]
});
export default ACTIVITY_WIDGETS;
